var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-0", attrs: { flat: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", dense: "", color: "transparent" } },
        [
          _c("v-toolbar-title", [
            _vm._v(_vm._s(_vm.$t("message.overtime.title"))),
          ]),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "pa-3" },
        [
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: "date",
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      label: _vm.$t("message.overtime.from"),
                    },
                    on: { change: _vm.loadData },
                    model: {
                      value: _vm.from,
                      callback: function ($$v) {
                        _vm.from = $$v
                      },
                      expression: "from",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: "date",
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      label: _vm.$t("message.overtime.to"),
                    },
                    on: { change: _vm.loadData },
                    model: {
                      value: _vm.to,
                      callback: function ($$v) {
                        _vm.to = $$v
                      },
                      expression: "to",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "text-center pa-2",
                      attrs: { outlined: "", loading: _vm.loading },
                    },
                    [
                      _c("div", { staticClass: "text-caption grey--text" }, [
                        _vm._v(_vm._s(_vm.$t("message.overtime.fifty"))),
                      ]),
                      _c("div", { staticClass: "text-h6 warning--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.formatFlexMinutes(
                              _vm.overview.overtime_50_minutes
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "text-center pa-2",
                      attrs: { outlined: "", loading: _vm.loading },
                    },
                    [
                      _c("div", { staticClass: "text-caption grey--text" }, [
                        _vm._v(_vm._s(_vm.$t("message.overtime.hundred"))),
                      ]),
                      _c("div", { staticClass: "text-h6 error--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.formatFlexMinutes(
                              _vm.overview.overtime_100_minutes
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "text-center pa-2",
                      attrs: { outlined: "", loading: _vm.loading },
                    },
                    [
                      _c("div", { staticClass: "text-caption grey--text" }, [
                        _vm._v(_vm._s(_vm.$t("message.overtime.total"))),
                      ]),
                      _c("div", { staticClass: "text-h6" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.formatFlexMinutes(
                              _vm.overview.overtime_total_minutes
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "mt-3", attrs: { outlined: "" } },
            [
              _c("v-card-title", { staticClass: "text-subtitle-1" }, [
                _vm._v(_vm._s(_vm.$t("message.overtime.entries"))),
              ]),
              _c("v-divider"),
              _vm.entries.length
                ? _c(
                    "v-list",
                    { attrs: { "two-line": "", dense: "" } },
                    _vm._l(_vm.entries, function (entry) {
                      return _c(
                        "v-list-item",
                        { key: entry.time_log_id },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$formatter.formatDate(
                                      entry.date,
                                      "YYYY-MM-DD",
                                      "DD.MM.YYYY"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "v-list-item-subtitle",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        color:
                                          entry.rate === 100
                                            ? "error"
                                            : "warning",
                                        "text-color": "white",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(entry.rate) + "% ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-list-item-action", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$formatter.formatFlexMinutes(
                                    entry.minutes
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c("v-card-text", { staticClass: "grey--text" }, [
                    _vm._v(_vm._s(_vm.$t("message.overtime.noEntries"))),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }